import * as t from './actionTypes';

export const setUserAgent = userAgent => ({
  type: t.SET_USER_AGENT,
  userAgent,
});

export const setRecaptchaSiteKey = siteKey => ({
  type: t.SET_RECAPTCHA_SITE_KEY,
  siteKey,
});

export const setRelease = release => ({
  type: t.SET_RELEASE,
  release,
});

export const setRouteName = routeName => ({
  type: t.SET_ROUTE_NAME,
  routeName,
});

export const setPollingIntervalId = pollingIntervalId => ({
  type: t.SET_INTERVAL_ID,
  pollingIntervalId,
});



// WEBPACK FOOTER //
// ./modules/App/redux/actions.js